import {
  GET_IMAGE_LIBRARIES_SUCCESS,
  GET_IMAGE_LIBRARY_SUCCESS,
  GET_USER_IMAGES_REQUESTED,
  GET_USER_IMAGES_FAILURE,
  GET_USER_IMAGES_SUCCESS,
  DELETE_USER_IMAGE_SUCCESS,
  SEARCH_IMAGE,
  SEARCH_IMAGE_FAILURE,
  SEARCH_IMAGE_SUCCESS
} from '../actionCreators/imagesActions';

const initialState = {
  tags: [],
  libraries: [],
  userImagesLoading: false,
  userImages: [],
  search: { results: [] }
};

export default function imagesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_IMAGE_LIBRARIES_SUCCESS:
      return {
        ...state,
        libraries: action.libraries
      };

    case GET_IMAGE_LIBRARY_SUCCESS:
      return {
        ...state,
        libraries: state.libraries.map(library => {
          if (library.id !== action.libraryId) return library;
          return {
            ...library,
            ...action.library,
            images: [...(library.images || []), ...action.library],
            cursor: action.cursor
          };
        })
      };

    case GET_USER_IMAGES_REQUESTED: {
      return {
        ...state,
        userImagesLoading: true
      };
    }

    case GET_USER_IMAGES_FAILURE: {
      return {
        ...state,
        userImagesLoading: false
      };
    }

    case GET_USER_IMAGES_SUCCESS: {
      return {
        ...state,
        userImagesLoading: false,
        userImages: action.payload
      };
    }

    case DELETE_USER_IMAGE_SUCCESS: {
      const userImages = state.userImages.filter(img => img.id !== action.imageId);
      return {
        ...state,
        userImages
      };
    }

    case SEARCH_IMAGE: {
      if (!action.offset) {
        return {
          ...state,
          search: {
            query: action.query
          }
        };
      }
      return {
        ...state,
        search: {
          ...state.search,
          query: action.query
        }
      };
    }

    case SEARCH_IMAGE_SUCCESS: {
      return {
        ...state,
        search: {
          ...state.search,
          results: [...(state.search.results || []), ...action.results],
          totalImages: action.totalImages
        }
      };
    }

    case SEARCH_IMAGE_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          error: action.error
        }
      };

    default:
      return state;
  }
}
